var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full -mt-4" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.$apollo.queries.currentUserInfo.loading,
            hasData: !!_vm.currentUserInfo,
          },
        },
        [
          !_vm.$apollo.queries.currentUserInfo.loading
            ? _c(
                "div",
                [
                  _c("PageHeadContainer", {
                    attrs: { title: _vm.title },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icons",
                          fn: function () {
                            return [
                              _c(
                                "PageHeadIcon",
                                {
                                  staticClass: "capitalize",
                                  attrs: { content: _vm.currentUserInfo.role },
                                },
                                [_c("BadgeIcon", { class: _vm.iconClasses })],
                                1
                              ),
                              _c(
                                "PageHeadIcon",
                                { attrs: { content: _vm.updatedAt } },
                                [_c("ClockIcon", { class: _vm.iconClasses })],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1019389108
                    ),
                  }),
                  _c(
                    "div",
                    { staticClass: "max-w-7xl mx-auto mb-8" },
                    [
                      _c("ProfileBasic", {
                        attrs: { userId: _vm.userId },
                        on: { update: _vm.updateDate },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }